import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getDirection, hardCopy, pexios, toast, uploadImages } from '../../utils/functions';
import { history, latinAlphabet } from '../../utils/variables';
import Input from '../../components/master/Input';
import UserData from "../../components/expert/details/UserData";
import ThirdData from "../../components/expert/details/ThirdData";
import CarData from "../../components/expert/details/CarData";
import Modal from "../../components/master/Modal";
import Switch from '../../components/master/Switch';
import { toast as toast2 } from 'react-toastify';
import { useTranslation } from 'react-i18next';

export default function LossesDetail() {

    const { id } = useSelector(store => store.routerData);
    const { t, i18n } = useTranslation();
    const [data, setData] = useState({
        attachments: [],
    });
    const [accident, setAccident] = useState({});
    const [index, setIndex] = useState(0);
    const [step, setStep] = useState(1);
    const [loader, setLoader] = useState(false);
    /////
    const [lossesObject, setLossesObject] = useState({
        type: '',
        count: '',
        herz: t('Has')
    })
    const [valueArray, setValueArray] = useState(data.details);
    const [objectInfo, setObjectInfo] = useState({
        owner_name: '',
        owner_type: ''
    })

    useEffect(() => {
        pexios('/api/v2/get_accident', 'post', { accident_id: id, type: 'losses' })
            .then(res => {
                setAccident(res.data.data);
            })
    }, [id]);

    useEffect(() => {
        if (!accident.losses) return;
        const accidentCopy = hardCopy(accident);
        const losses = accident?.losses[index];
        const { car = {}, user = {} } = losses || {};
        const { third = {} } = car || {};
        delete accidentCopy?.losses;
        delete accidentCopy?.user;
        delete user?.attachments;
        delete user?.avatar;
        delete user?.type;
        delete car?.third;
        delete losses?.car;
        delete losses?.user;
        const data = { ...accidentCopy, ...car, ...user, ...losses, third };
        setData(data);
        ////
        setValueArray(data.details)
        if (losses?.type === 'object') {
            setObjectInfo({
                owner_name: data.owner_name || '',
                owner_type: data.owner_type || ''
            })
        }
    }, [accident, index]);
    useEffect(() => {
        setValueArray(valueArray)
    }, [valueArray])

    function finishUpload(image, name, done) {
        uploadImages({
            id,
            type: 'accident',
            name,
            image,
            done,
            callback: (data) => {
                setData(prevState => ({
                    ...prevState,
                    attachments: [
                        ...prevState.attachments,
                        data,
                    ],
                }));
            },
        });
    }
    function changeData(value, name, type) {
        setData(prevState => ({
            ...prevState,
            ...(type
                ? {
                    [type]: {
                        ...prevState[type],
                        [name]: value
                    }
                }
                : { [name]: value }
            )
        }));
    }

    function changeStep(step) {
        if (step === 5) {
            submit();
            return;
        }
        setStep(step);
        const element = document.getElementById('content');
        setTimeout(() => element.scrollIntoView());
    }

    function submit() {
        setLoader(true);
        pexios('/api/update_losses', 'post', { ...data })
            .then(() => {
                if (Number(index) + 1 !== Number(accident.losses.length)) {
                    setLoader(false);
                    setIndex(prevState => (prevState + 1));
                    setStep(1);
                } else history.push('/expert-images');
            });
    }
    ////

    function changeLossesObject(type, val, index) {
        setValueArray(prevState => prevState.map((item, i) => {
            if (index === i) {
                return {
                    ...item,
                    [type]: val
                }
            } else {
                return item
            }
        }))
    }
    function objectLossesHandler() {
        //const objectDetails = JSON.stringify(valueArray)
        const info = {
            details: valueArray,
            owner_name: objectInfo.owner_name,
            owner_type: objectInfo.owner_type,
            id: data.id
        }
        setLoader(true);
        pexios('/api/update_object_losses', 'post', { ...info })
            .then(() => {
                if (Number(index) + 1 !== Number(accident.losses.length)) {
                    setLoader(false);
                    setIndex(prevState => (prevState + 1));
                    setStep(1);
                } else history.push('/expert-images');
            });
    }
    function addElement() {
        if (lossesObject.type !== '' && lossesObject.count !== '') {
            valueArray.push(lossesObject);
            setValueArray(valueArray)
            setLossesObject({
                type: '',
                count: '',
                herz: 'دارد'
            })
        } else {
            toast(t('Please complete the feilds'), 'error');
        }
    }
    function removeElement(index) {
        toast2.dismiss()
        if (valueArray.length === 1 && valueArray[0].type !== '') {
            toast(t('You can not delete the last option'), 'error');
        } else {
            let data = hardCopy(valueArray);
            data.splice(index, 1)
            setValueArray(data);
            // valueArray.splice(index, 1);
            // setValueArray(()=>valueArray)
            // // setLossesObject({
            // //     type: '',
            // //     count: '',
            // //     herz: 'دارد'
            // // })
        }
    }
    return (
        <div className='content details'>
            <Modal visible={loader}>
                <div className='loader-modal'>
                    <p>{t('Loading')}</p>
                    <i className='fas fa-spinner fa-spin' />
                </div>
            </Modal>
            <div id='content' />
            {
                step === 1 &&
                <>
                    {
                        data.type === 'car'
                            ? <UserData
                                data={data}
                                userType='losses'
                                lossesIndex={index}
                                changeData={changeData}
                                uploadImage={finishUpload}
                                changeStep={changeStep}
                            />
                            :
                            data.type === 'object' && <>
                                <h4 className='mt20 text-center border-title'>{`${t('Losses info')} ${t(latinAlphabet[index])}`}</h4>
                                <div className={`row ${getDirection(i18n.language) ==='rightToLeft'?'text-right':'text-left'}`}>
                                    <Input
                                        label={t('Owner name')}
                                        value={objectInfo.owner_name}
                                        onChange={(value) => setObjectInfo(prevState => ({ ...prevState, owner_name: value }))}
                                    
                                    />

                                    <div className='select-input mt20 mb5 col-6'>
                                        <label>{t('Owner type')}</label>
                                        <select className='form-control' onChange={(e) => setObjectInfo(prevState => ({ ...prevState, owner_type: e.target.value }))}>
                                            <option value={t('General')} >{t('General')}</option>
                                            <option value={t('Special')} >{t('Special')}</option>
                                        </select>
                                    </div>
                                </div>
                                <div className={`mt20 row ${getDirection(i18n.language) ==='rightToLeft'?'text-right':'text-left'}`}>
                                    {valueArray.map((item, index) => (
                                        <div className='row col-12 text-right losses-detail' key={index}>
                                            <div className='cancle-btn'>
                                                <i className='fas fa-times close-btn' onClick={() => removeElement(index)} />
                                            </div>
                                            <Input
                                                label={t('Type')}
                                                value={item.type}
                                                onChange={(value) => changeLossesObject('type', value, index)}

                                            />

                                            <Input
                                                label={t('Number')}
                                                value={item.count}
                                                onChange={(value) => changeLossesObject('count', value, index)}
                                                type='number'

                                            />
                                            <div className='row align-items-center justify-space-between'>
                                                <div className='row'>

                                                    <Switch
                                                        value={item.herz === t('Has') ? true : false}
                                                        onChange={(value) => changeLossesObject('herz', value === true ? t('Has') : t('Has not'), index)}
                                                    />
                                                    <label className='pr20 p20'>{t('Has herz?')}</label>
                                                </div>
                                            </div>

                                        </div>
                                    ))}
                                </div>
                                <div className={`row ${getDirection(i18n.language) ==='rightToLeft'?'text-right':'text-left'} losses-detail mt20 col-12`}>
                                    <Input
                                        label={t('Type')}
                                        value={lossesObject.type}
                                        onChange={(value) => setLossesObject(prevState => ({ ...prevState, 'type': value }))}
                                    />
                                    <Input
                                        label={t('Number')}
                                        value={lossesObject.count}
                                        type='number'
                                        onChange={(value) => setLossesObject(prevState => ({ ...prevState, 'count': value }))}

                                    />
                                    <div className='col-12 row align-items-center justify-space-between'>
                                        <div className='row'>
                                            <Switch
                                                value={lossesObject.herz === t('Has') ? true : false}
                                                onChange={(value) => setLossesObject(prevState => ({ ...prevState, 'herz': value === true ? t('Has') : t('Has not') }))}
                                            />
                                            <label className='pr10 pt15'>{t('Has herz?')}</label>
                                        </div>
                                        <button onClick={addElement}
                                            className='btn btn-blue btn-circle mt20 add-btn'>
                                            {t('Add')}
                                        </button>
                                    </div>

                                </div>

                                <div className='mt20 pr5 pl-5'>
                                    {/* <button onClick={() => history.push('/final-pricing', {index})}
                                            className='btn btn-green btn-block btn-circle'>
                                        مرحله بعد
                                    </button> */}
                                    <button onClick={objectLossesHandler}
                                        className='btn btn-green btn-block btn-circle'>
                                        {t('Next step')}
                                    </button>
                                </div>
                            </>
                    }
                </>
            }
            {
                step === 2 &&
                <ThirdData
                    data={data}
                    userType='losses'
                    lossesIndex={index}
                    changeData={changeData}
                    uploadImage={finishUpload}
                    changeStep={changeStep}
                />
            }
            {
                step === 4 &&
                <CarData
                    data={data}
                    userType='losses'
                    lossesIndex={index}
                    changeData={changeData}
                    uploadImage={finishUpload}
                    changeStep={changeStep}
                />
            }
        </div>
    );

};
